import { IDMSUILine } from "../navdata";
import { IBrigdeOptions } from 'src/extern/csBridge';

export interface IDialogService {
    /** Show 'Blocking Error To User' */
    ShowError(message: any, title?: string): PromiseLike<void>;

    /** Show Confirm Message to User */
    ShowConfirm(options: string | { title?: string; message: string; messageIsHtml?: boolean }): PromiseLike<boolean>;

    /** Show Confirm with Implicit promise reject when user cancels */
    WhenConfirm(options: string | { title?: string; message: string; messageIsHtml?: boolean, Ignore?: IMessageIgnore });

    /** Show a Message Dialog */
    ShowDialog(options: { title?: string; message: string; messageIsHtml?: boolean, Ignore?: IMessageIgnore } | string);

    /** Generic show Window */
    ShowWindow(options: IDialogRoute): PromiseLike<IDialogState>;

    /** Show an Input Dialog for simple text */
    ShowInput(options: { title: string; message: string; messageIsHtml?: boolean; inputText?: string; isPassword?: boolean }): PromiseLike<{
        okPressed?: boolean,
        inputString: string
    }>;

    /** Show User Choice */
    ShowQuestion<T>(options: {
        title?: string;
        message: string;
        Ignore?: IMessageIgnore;
        messageIsHtml?: boolean;
        answers: Array<{ caption: string; result: T; /** Wird initial Selektiert, Antwort bei Abbruch */default?: boolean }>;
        choiceType?: ChoiceType;
    }): PromiseLike<T>;

    /** Answer Backend Comfirm message (i.e) : set Answer */
    UIAnswerConfirmMessage(item: IDMSUILine): PromiseLike<void>;

    /** Sign Documents by User */
    ModalSignDocument<TSignDoc extends IKWFSignDoc>(signOptions: IKWFSignOptions, signDocs: PromiseLike<TSignDoc[]> | any[]): PromiseLike<TSignDoc[]>;
}

/** Cancellable Event broadcasted when Dialog is about to be opened [see TDeferAngularEvent],
      * first argument is an object where Promises can be attached by name which will be resolved before open (reject will cancel Open) */
export const $ModalOpen = "$ModalOpen";
/** Event Fired when Dialog got opened */
export const $ModalOpened = "$ModalOpened";
/** Event broadcasted before Close */
export const $ModalClose = "$ModalClose";
/** Cancellable Event emitted on Modal Scope [see TDeferAngularEvent] */
export const $ModalRequestClose = "$ModalRequestClose";

/** Get Full Message from Item */
export function GetMessage(msgItem: IDMSUILine) {
    return ["Message_Text", "Message_Text_2", "Message_Text_3", "Message_Text_4", "Message_Text_5"].map(item => msgItem[item]).join("").replace("\\", "\n");
}

export enum ChoiceType {
    Button, Choice
}

/** Defer Action Helper Interfaec */
export interface TDefer {
    /** Add Factory to Create a Promise that will defer the execution after promises are resolved*/
    Defer(pFactory: () => PromiseLike<any>): void;
}

/** 'Route' Object for Dialog Display */
export interface IDialogRoute<TController = any> {
    /** we support only string Urls (no Route Params) */
    templateUrl?: string;
    template?: string;
    /** we support resolve of Controller; any[] is not documented, will work in base also*/
    controller?: TController extends new (...args: any[]) => infer TControllerClass ? TControllerClass : any; // string | Function | any[];
    controllerAs?: string;
    resolve?: { [key: string]: string | Function | [] };
    /** Options for the kendo Window */
    windowOptions?: kendo.ui.WindowOptions;
    mobile?: {
            fullScreen?: true
    };
    /** Formula Determining the title Calculated from Generated Scope */
    titleFormula?: string;
    // those Props defined on Route make no sense here
    //redirectTo?: string | { ($routeParams?: angular.route.IRouteParamsService, $locationPath?: string, $locationSearch?: any): string };
    //reloadOnSearch?: boolean;
    //caseInsensitiveMatch?: boolean;
}

/** State Info Returned from DialogService.ShowWindow */
export interface IDialogState {
    controller?: any;
    scope: ng.IScope;
    close: PromiseLike<any>;
    closeDialog(): void;
}

/** State info about possibly ignored Messages */
export interface IMessageIgnore {
    IsIgnored?: boolean;
    IgnoreMessage?: string;
}

/** Signature Dokument information */
export interface IKWFSignDoc {
    /** Name of the Document to Sign */
    Name: string;
    /** Input/Output Content (Base64 Encoded) */
    Base64Content: string;
    /** no. of Previous Signatures in Document */
    PreviousSignatureCount: number;

    // Initialisierung\n03.07.2015
    Text: string;

    Info: {
        Name: string;
        Reason: string;
        Location: string;
        ContactInfo: string;
    };

    /** IconData to Attach (resolved internally from PreviousSignatureCount) */
    IconDataBase64?: string;
}

export interface IKWFSignOptions {
    SerialNo: string;
    // Sign Operation via Procilon ProGOV
    ProGOV? : true;
    // Sign Operation via Intarsys Bridge
    Bridge?: IBrigdeOptions;
}
